import { Fragment, VFC } from 'react';
import { FormItemProps } from 'components/Form/FormItem';
import { WaterMeterDetailField } from './constants';
import { getWaterDetailFormItem, AdditionalWaterDetails } from './utils/getDetailFormItem';

interface WaterDetailsProps {
  itemsConfig: Partial<
    Record<
      WaterMeterDetailField,
      {
        formItemProps?: FormItemProps;
        additionalConfig?: AdditionalWaterDetails;
      }
    >
  >;
}

export const WaterDetails: VFC<WaterDetailsProps> = ({ itemsConfig }) => {
  return (
    <>
      {Object.entries(itemsConfig).map(([item, { additionalConfig = {}, formItemProps = {} }]) => (
        <Fragment key={item}>
          {getWaterDetailFormItem(item as WaterMeterDetailField, formItemProps, additionalConfig)}
        </Fragment>
      ))}
    </>
  );
};
